/**
 * UI Dialog Directive works as a placeholder for any dialog being initiaded
 */

import {
  Component,
  ComponentRef,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { ComponentCreatorService } from '../services/component-creator.service';
import { NotifierService } from '../services/notifier.service';
import { UIActiveDialogService } from '../services/ui-dialog.service';

declare var jQuery: any;

@Component({
  selector: 'popup-dialog',
  template: `
    <div
      class="modal fade"
      id="popupDialogId"
      data-backdrop="static"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" role="document" #modalDialog>
        <div class="modal-content"><div #view></div></div>
      </div>
    </div>
  `
})
export class UIDialogDirective implements OnDestroy {
  @Input('name') name: string;
  @ViewChild('view', { static: true, read: ViewContainerRef })
  view: ViewContainerRef;
  @ViewChild('modalDialog', { static: true }) el: ElementRef;

  popupDialog: any;

  cmpRef: ComponentRef<{}>; // Instace of the component

  resolve: any;
  reject: any;

  openNotifier: any;
  closeNotifier: any;
  dismissNotifier: any;

  constructor(
    private notifierService: NotifierService,
    private activeDialog: UIActiveDialogService,
    private compCreator: ComponentCreatorService
  ) {
    this.registerListeners();
  }

  ngAfterViewInit(): void {
    this.popupDialog = jQuery('#popupDialogId');
  }

  /**
   * Clear resources on destroy
   */
  ngOnDestroy(): void {
    if (this.cmpRef) {
      this.popupDialog.modal('hide');
      this.cmpRef.destroy();
    }
    this.openNotifier();
    this.closeNotifier();
    this.dismissNotifier();
  }

  /**
   * Register the listener to handle dialog events
   */
  private registerListeners(): void {
    this.openNotifier = this.notifierService.on('dialog.open', event => {
      // make sure UI has no other open dialog
      if (this.cmpRef) {
        this.cmpRef.destroy();
        this.popupDialog.modal('hide');
        this.reject('OTHER_DIALOG_OPENED');
      }

      this.reject = event.reject;
      this.resolve = event.resolve;
      this.cmpRef = this.compCreator.insert(
        event.component,
        event.params,
        this.view
      );

      this.activeDialog.componentInstance = this.cmpRef;

      this.popupDialog.modal('show');
    });

    this.closeNotifier = this.notifierService.on('dialog.close', event => {
      if (this.cmpRef) {
        this.el.nativeElement.style.top = 'initial';
        this.el.nativeElement.style.left = 'initial';
        this.popupDialog.modal('hide');
        this.resolve(event.result);
        this.cmpRef.destroy();
      }
    });

    this.dismissNotifier = this.notifierService.on('dialog.dismiss', event => {
      if (this.cmpRef) {
        this.el.nativeElement.style.top = 'initial';
        this.el.nativeElement.style.left = 'initial';
        this.popupDialog.modal('hide');
        this.reject(event.result);
        this.cmpRef.destroy();
      }
    });
  }
}
